interface NotificationMessage {
    message: string;
    dom: HTMLElement;
    order: number;
}

export class Notification {
    private messages: NotificationMessage[] = [];

    public notify(message: string) {
        this.pushMessage(message, "success");
    }

    public error(message: string) {
        this.pushMessage(message, "error");
    }

    private pushMessage(message: string, cssClass: string) {
        const element = document.createElement("div");
        element.classList.add("notification", cssClass);
        element.innerText = message;
        document.body.appendChild(element);

        this.moveUpMessages();

        const theMessage = {
            message,
            dom: element,
            order: 0
        };

        this.messages.push(theMessage);

        setTimeout(() => {
            element.classList.add("open-0");
        }, 10);

        setTimeout(() => {
            element.classList.add(`close-${theMessage.order}`);
            element.classList.remove(`open-${theMessage.order}`);
            setTimeout(() => {
                element.remove();
                const idx = this.messages.indexOf(theMessage);
                if (idx != -1) this.messages.splice(idx, 1);
            }, 500);
        }, 5000);
    }

    private moveUpMessages() {
        this.messages.forEach((m) => {
            m.dom.classList.remove(`open-${m.order}`);
            m.order += 1;
            m.dom.classList.add(`open-${m.order}`);
        });
    }
}
